
import { Button } from "@/components/ui/button";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface PhoneNumberFormProps {
  phoneNumber: string;
  loading: boolean;
  onPhoneNumberChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const PhoneNumberForm = ({
  phoneNumber,
  loading,
  onPhoneNumberChange,
  onSubmit,
}: PhoneNumberFormProps) => {
  return (
    <form onSubmit={onSubmit} className="mt-8 space-y-6 w-full flex flex-col items-center">
      <div className="space-y-2 w-full max-w-sm">
        <label htmlFor="phone" className="block text-sm font-medium text-card-foreground text-center">
          Phone Number
        </label>
        <div className="flex justify-center w-full">
          <PhoneInput
            id="phone"
            international
            defaultCountry="ZA"
            value={phoneNumber}
            onChange={(value) => onPhoneNumberChange(value || "")}
            autoFocus
            className="w-full"
          />
        </div>
        <p className="text-sm text-muted-foreground mt-1 text-center">
          Enter your phone number with country code
        </p>
      </div>

      <Button 
        type="submit" 
        className="w-full max-w-sm shadow-md hover:shadow-lg transition-all duration-200"
        size="lg"
        disabled={loading || !phoneNumber}
      >
        {loading ? "Sending..." : "Send Verification Code"}
      </Button>
    </form>
  );
};
